<div class="calendar-container">
  <div class="heading form-container">
    <div>
      <span class="arrow" (click)="previous()" *ngIf="isCurrentMonthNotInPast()"><i class="fa fa-angle-left"></i></span>
      <span class="current_month">
        <span class="bold">{{ 'CALENDAR.MONTHS[' + (month.month() + 1) + ']' | translate }}</span>
        {{ month.format('YYYY') }}
      </span>
      <span class="arrow" (click)="next()"><i class="fa fa-angle-right"></i></span>
      <eps-button
        label="CALENDAR.SHOW_TODAY"
        (buttonClick)="showToday()"
        ></eps-button>
      <span class="header-message" *ngIf="headerMessage">{{ headerMessage | translate }}</span>
    </div>
      <form [formGroup]="calendarForm" class="row">
        <eps-date-input
          class="col-12"
          formControlName="calendarDate"
          [(ngModel)]="date"
          (ngModelChange)='onDateChanged($event)'
          label="CALENDAR.JUMP_TO_DATE"
          labelWidth="50%"
          hideOptionalMarker
          [clearable]="false"
        ></eps-date-input>
      </form>
  </div>
  <div class="calendar">
    <div class="day_names">
      <span class="day_name">{{ 'SHARED.DAYS.MONDAY' | translate }}</span>
      <span class="day_name">{{ 'SHARED.DAYS.TUESDAY' | translate }}</span>
      <span class="day_name">{{ 'SHARED.DAYS.WEDNESDAY' | translate }}</span>
      <span class="day_name">{{ 'SHARED.DAYS.THURSDAY' | translate }}</span>
      <span class="day_name">{{ 'SHARED.DAYS.FRIDAY' | translate }}</span>
      <span class="day_name weekend">{{ 'SHARED.DAYS.SATURDAY' | translate }}</span>
      <span class="day_name weekend">{{ 'SHARED.DAYS.SUNDAY' | translate }}</span>
    </div>
    <div class="week" *ngFor="let week of weeks">
      <div class="day" *ngFor="let day of week.days">
        <app-calendar-day
          class="day_inner"
          [day]="day"
          [selectedDay]="selectedDay"
          [customers]="days.legend"
          [tooltipRef]="tooltipRef"
          (showFlorderModal)="showFlorderModal.emit($event)"
          (openFlorder)="openFlorder.emit($event)"
        >
        </app-calendar-day>
      </div>
    </div>
  </div>
</div>
